import Vue from "vue";
import Router from "vue-router";
import Home from "@/views/Home.vue";
import Chords from "@/views/Chords.vue";
import PublicSubmit from "@/views/PublicSubmit.vue";
import SongQuery from "@/views/SongQuery.vue";
import Search from "@/views/Search.vue";

// route level code-splitting
// this generates a separate chunk (about.[hash].js) for this route
// which is lazy-loaded when the route is visited.

const About = () => import(/* webpackChunkName: "about" */ "./views/About.vue");
const Review = () =>
  import(/* webpackChunkName: "review" */ "./views/Review.vue");

const NotFound = () =>
  import(/* webpackChunkName: "review" */ "./views/NotFound.vue");

Vue.use(Router);

export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/home",
      name: "home",
      component: Home
    },
    {
      path: "/",
      name: "front",
      component: SongQuery,
      meta: {
        content: "playalong",
        onlyKnownChords: true,
        onlyFavoriteIds: false,
        showHeaderOnFirstPage: true
      }
    },
    {
      path: "/:tuning/favorites/known-chords/",
      name: "favorites-known-chords",
      component: SongQuery,
      meta: {
        content: "all",
        onlyKnownChords: true,
        onlyFavoriteIds: true
      }
    },
    {
      path: "/:tuning/favorites/",
      name: "favorites",
      component: SongQuery,
      meta: {
        content: "all",
        onlyKnownChords: false,
        onlyFavoriteIds: true
      }
    },
    {
      path: "/:tuning/playalongs/",
      name: "playalongs",
      component: SongQuery,
      meta: {
        content: "playalong",
        onlyKnownChords: false,
        onlyFavoriteIds: false
      }
    },
    {
      path: "/:tuning/playalongs/known-chords/",
      name: "playalongs-known-chords",
      component: SongQuery,
      meta: {
        content: "playalong",
        onlyKnownChords: true,
        onlyFavoriteIds: false
      }
    },

    {
      path: "/:tuning/tutorials",
      name: "tutorials",
      component: SongQuery,
      meta: {
        content: "tutorial",
        onlyKnownChords: false,
        onlyFavoriteIds: false
      }
    },
    {
      path: "/:tuning/tutorials/known-chords/",
      name: "tutorials-known-chords",
      component: SongQuery,
      meta: {
        content: "tutorial",
        onlyKnownChords: true,
        onlyFavoriteIds: false
      }
    },

    {
      path: "/:tuning/all/",
      name: "all",
      component: SongQuery,
      meta: {
        content: "all",
        onlyKnownChords: false,
        onlyFavoriteIds: false
      }
    },
    {
      path: "/:tuning/all/known-chords/",
      name: "all-known-chords",
      component: SongQuery,
      meta: {
        content: "all",
        onlyKnownChords: true,
        onlyFavoriteIds: false
      }
    },
    {
      path: "/public/submit",
      name: "public-submit",
      component: PublicSubmit,
      meta: {
        login_required: false
      }
    },
    {
      path: "/:tuning/chords",
      name: "chords",
      component: Chords,
      meta: {
        login_required: false
      }
    },
    {
      path: "/:tuning/search",
      name: "search",
      component: Search,
      meta: {
        login_required: false
      }
    },
    {
      path: "/about",
      name: "about",
      component: About
    },
    {
      path: "/admin/review",
      name: "review",
      component: Review,
      meta: {
        login_required: true
      }
    },
    {
      path: "/playalongs",
      redirect: { name: "playalongs", params: { tuning: "C" } }
    },
    {
      path: "/playalongs/known-chords",
      redirect: { name: "playalongs", params: { tuning: "C" } }
    },
    {
      path: "/tutorials",
      redirect: { name: "tutorials", params: { tuning: "C" } }
    },
    {
      path: "/tutorials/known-chords",
      redirect: { name: "tutorials", params: { tuning: "C" } }
    },
    {
      path: "/favorites",
      redirect: { name: "favorites", params: { tuning: "C" } }
    },
    {
      path: "/favorites/known-chords",
      redirect: { name: "favorites", params: { tuning: "C" } }
    },
    {
      path: "/chords",
      redirect: { name: "chords", params: { tuning: "C" } }
    },
    { path: "/videos", redirect: { name: "front" } },
    { path: "*", component: NotFound }
  ]
});
